// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eFyW","rootNoMargin":"styles_rootNoMargin__3tHeY"};